import script from "./CommonFilePreView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonFilePreView.vue?vue&type=script&lang=ts&setup=true"

import "./CommonFilePreView.vue?vue&type=style&index=0&id=bfd7b914&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfd7b914"]])

export default __exports__